"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const TokenCreator_1 = __importDefault(require("./TokenCreator"));
const Token_1 = __importDefault(require("./Token"));
const useTokenInputFocusEffect_1 = __importDefault(require("./hooks/useTokenInputFocusEffect"));
const useTokenCreatorRef_1 = __importDefault(require("./hooks/useTokenCreatorRef"));
const useTokensUpdate_1 = __importDefault(require("./hooks/useTokensUpdate"));
const useTokenEdit_1 = __importDefault(require("./hooks/useTokenEdit"));
const useTokenDelete_1 = __importDefault(require("./hooks/useTokenDelete"));
const defaultTokenValueValidate_1 = __importDefault(require("./utils/defaultTokenValueValidate"));
const defaultBuildTokenValue_1 = __importDefault(require("./utils/defaultBuildTokenValue"));
const defaultGetIsTokenEditable_1 = __importDefault(require("./utils/defaultGetIsTokenEditable"));
const defaultGetTokenEditableValue_1 = __importDefault(require("./utils/defaultGetTokenEditableValue"));
const defaultGetTokenErrorMessage_1 = __importDefault(require("./utils/defaultGetTokenErrorMessage"));
const constants_1 = require("./constants");
const styles_scss_1 = __importDefault(require("./styles.scss"));
const TokenInput = (props, ref) => {
    const { className, placeholder, readOnly = false, autoFocus = false, disableCreateOnBlur, tokenValues, separators = constants_1.DEFAULT_SEPARATORS, specialKeyDown = constants_1.DEFAULT_SPECIAL_KEY_DOWN_CONFIG, onInputValueChange, onPreprocess, onTokenValueValidate = defaultTokenValueValidate_1.default, onTokenValuesChange, onBuildTokenValue = defaultBuildTokenValue_1.default, customizeTokenComponent, onGetTokenClassName, onGetTokenDisplayLabel = defaultGetTokenEditableValue_1.default, onRenderTokenDeleteButtonContent, onGetIsTokenEditable = defaultGetIsTokenEditable_1.default, onGetTokenEditableValue = defaultGetTokenEditableValue_1.default, onGetTokenErrorMessage = defaultGetTokenErrorMessage_1.default, onCreatorFocus, onCreatorBlur, onCreatorKeyDown } = props, restProps = __rest(props, ["className", "placeholder", "readOnly", "autoFocus", "disableCreateOnBlur", "tokenValues", "separators", "specialKeyDown", "onInputValueChange", "onPreprocess", "onTokenValueValidate", "onTokenValuesChange", "onBuildTokenValue", "customizeTokenComponent", "onGetTokenClassName", "onGetTokenDisplayLabel", "onRenderTokenDeleteButtonContent", "onGetIsTokenEditable", "onGetTokenEditableValue", "onGetTokenErrorMessage", "onCreatorFocus", "onCreatorBlur", "onCreatorKeyDown"]);
    const { isTokenInputFocused, handleTokenInputFocus, handleTokenInputBlur, handleCreatorFocus, handleCreatorBlur, } = (0, useTokenInputFocusEffect_1.default)({
        onCreatorFocus,
        onCreatorBlur,
    });
    const { tokenCreatorRef, focusTokenCreator, setCreatorValue, getCreatorValue, createTokens, } = (0, useTokenCreatorRef_1.default)();
    const { hasInvalidToken, internalTokenValues, tokenMetas, setTokenActivated, } = (0, useTokensUpdate_1.default)({
        tokenValues,
        onTokenValueValidate,
    });
    const { handleTokenEditStart, handleTokenEditEnd } = (0, useTokenEdit_1.default)({
        tokenValues,
        onTokenValuesChange,
        setTokenActivated,
        handleTokenInputFocus,
        handleTokenInputBlur,
    });
    const { handleTokenDelete, handleLastTokenDelete } = (0, useTokenDelete_1.default)({
        tokenValues,
        onTokenValuesChange,
        focusTokenCreator,
    });
    const handleNewTokenValuesAppend = (0, react_1.useCallback)((appendTokenValues) => {
        if (appendTokenValues.length === 0) {
            return;
        }
        const newTokenValues = [...tokenValues, ...appendTokenValues];
        onTokenValuesChange === null || onTokenValuesChange === void 0 ? void 0 : onTokenValuesChange(newTokenValues);
    }, [tokenValues, onTokenValuesChange]);
    const handleInputValuesPreprocess = (0, react_1.useCallback)((inputValues) => {
        if (typeof onPreprocess !== 'function') {
            return inputValues;
        }
        const processedValues = onPreprocess(inputValues);
        if (Array.isArray(processedValues) !== true) {
            throw new Error('onPreprocess should return an array of values');
        }
        return processedValues;
    }, [onPreprocess]);
    const handleClick = (0, react_1.useCallback)(() => focusTokenCreator(), [focusTokenCreator]);
    const TokenComponent = customizeTokenComponent || Token_1.default;
    (0, react_1.useImperativeHandle)(ref, () => ({
        focus: focusTokenCreator,
        setCreatorValue,
        getCreatorValue,
        createTokens,
    }), [focusTokenCreator, setCreatorValue, getCreatorValue, createTokens]);
    return (react_1.default.createElement("div", Object.assign({ "data-component-name": "TokenInput" }, restProps, { className: (0, classnames_1.default)(className, styles_scss_1.default.container, {
            [styles_scss_1.default['container--focused']]: isTokenInputFocused,
            [styles_scss_1.default['container--errors']]: hasInvalidToken,
        }), onClick: handleClick, role: "presentation" }),
        react_1.default.createElement("div", { className: styles_scss_1.default['token-list'] }, internalTokenValues.map((tokenValue, index) => {
            const tokenMeta = tokenMetas[index];
            const { key } = tokenMeta;
            return (react_1.default.createElement(TokenComponent, { key: key, readOnly: readOnly, tokenValue: tokenValue, tokenMeta: tokenMeta, onGetClassName: onGetTokenClassName, onGetDisplayLabel: onGetTokenDisplayLabel, onRenderDeleteButtonContent: onRenderTokenDeleteButtonContent, onGetIsEditable: onGetIsTokenEditable, onGetEditableValue: onGetTokenEditableValue, onGetErrorMessage: onGetTokenErrorMessage, onBuildTokenValue: onBuildTokenValue, onEditStart: handleTokenEditStart(index), onEditEnd: handleTokenEditEnd(index), onDelete: handleTokenDelete(index) }));
        })),
        !readOnly && (react_1.default.createElement(TokenCreator_1.default, { ref: tokenCreatorRef, placeholder: placeholder, autoFocus: autoFocus, disableCreateOnBlur: disableCreateOnBlur, onFocus: handleCreatorFocus, onBlur: handleCreatorBlur, onKeyDown: onCreatorKeyDown, separators: separators, specialKeyDown: specialKeyDown, onInputValueChange: onInputValueChange, onPreprocess: handleInputValuesPreprocess, onBuildTokenValue: onBuildTokenValue, onNewTokenValuesAppend: handleNewTokenValuesAppend, onLastTokenDelete: handleLastTokenDelete }))));
};
const WrappedTokenInput = (0, react_1.forwardRef)(TokenInput);
exports.default = WrappedTokenInput;
